import { receiveRetailerSettings } from './js/actions/retailerSettings';
import { receiveReturnsSettings } from './js/actions/returnsSettings';
import { setLanguage } from './js/actions/language';
import {
  updateLocale,
  updateGiftFlag,
  updateSecureMode,
  storeOverrideCode,
  generateBrowserFingerprint,
  receiveInitialPageLoadParams,
  receivePickupsModalVersion,
  receivePickupsEnableCTA,
  receiveAccessToken,
} from './js/actions/page';
import { generateLandingPageForm } from './js/actions/landingPage';
import { getUrlInfo, modifyUrlParams } from './js/lib/url';
import app from './app';
import { receiveLocationTagSettings } from './js/actions/storeLocator';
import { receiveUserPreferencesEnabled } from './js/actions/userPreferences';
import { receiveMultiOrderFlag } from './js/actions/multiOrders';
import { loadCurrencyFormat } from './js/startup/loadCurrencyFormats';
import { store } from './js/store';
import { receiveClaimsFlag } from './js/actions/claims';
import { setItemsLayout } from './js/actions/itemsPage';
import { receiveSublimeNarvarAppCta } from './js/actions/appCta';

const settingsLocale =
  window.returnsSettings &&
  window.returnsSettings.returns &&
  window.returnsSettings.returns.locale &&
  window.returnsSettings.returns.locale.default
    ? window.returnsSettings.returns.locale.default
    : null;

const {
  params,
  params: { locale = settingsLocale, gift = false, code, userType, usertype, exception } = {},
} = getUrlInfo();

const bootstrapApp = Promise.all([
  Promise.resolve(store.dispatch(updateLocale(locale))).then(() =>
    store.dispatch(setLanguage(window.langProperties)),
  ),
  loadCurrencyFormat(store, locale),
  store.dispatch(receiveRetailerSettings(window.retailerJSON)),
  store.dispatch(receiveReturnsSettings(window.returnsSettings)),
  store.dispatch(updateSecureMode(window.secureMode)),
  store.dispatch(receivePickupsModalVersion(window.pickupsModalVersion)),
  store.dispatch(receivePickupsEnableCTA(window.pickupsEnableCTA)),
  store.dispatch(receiveAccessToken(window.accessToken)),
  store.dispatch(receiveInitialPageLoadParams(params)),
  store.dispatch(updateGiftFlag(Boolean(gift))),
  store.dispatch(storeOverrideCode(code || userType || usertype || exception)),
  store.dispatch(generateLandingPageForm()),
  store.dispatch(generateBrowserFingerprint()),
  store.dispatch(receiveLocationTagSettings(JSON.parse(window.locationTagSettings || '{}'))),
  store.dispatch(receiveUserPreferencesEnabled(window.customerProfileEnabled)),
  store.dispatch(receiveMultiOrderFlag(window.returnsMultiOrderEnabled)),
  store.dispatch(receiveClaimsFlag(window.assistUnificationEnabled)),
  store.dispatch(setItemsLayout(window.itemsLayout)),
  store.dispatch(receiveSublimeNarvarAppCta(window.sublimeNarvarAppCta || '{}')),
]);

bootstrapApp.then(() => {
  // Delete sensitive URL params after it has been cached in bootstrapApp
  modifyUrlParams({
    paramsToDelete: ['order', 'email', 'dzip', 'bzip', 'phone', 'expired', 'init'],
  });
  app({ store });
});

export { store };
